import React, { FC } from 'react';
import clsx from 'clsx';
import styles from './TopMenu.module.scss';
import { ReactComponent as GoBackIcon } from 'images/new-icons/arrow-go-back.svg';
import { ReactComponent as ShareIcon } from 'images/new-icons/share-icon.svg';
import { ReactComponent as ShareIconDark } from 'images/new-icons/share-filled-dark.svg';
import { useSpring } from '@react-spring/web';
import { useActions } from 'store/useActions';
import ShareDrawer from '../ShareDrawer';

type Props = {
  dark?: boolean;
  handleBack?: () => void;
  setIsBooking?: React.Dispatch<React.SetStateAction<boolean>>;
  share?: any;
};

const TopMenuWithShare: FC<Props> = ({ dark, handleBack, share }) => {

  return (
    <div className={clsx(styles.container)}>
      <GoBackIcon
        onClick={() => {
          handleBack?.();
        }}
      />
      <div onClick={share}>{dark ? <ShareIconDark /> : <ShareIcon />}</div>
    </div>
  );
};

export default TopMenuWithShare;
